// Gemstone collection cards: fill each card's color/cut swatch row after the page
// has loaded. Building every linked color product server-side pushed big
// collections (e.g. /collections/rings) past Shopify's 10 s render limit (500s).
// Each row comes from /products/<handle>?view=ts-swatches, which Shopify caches
// per product, so it is shared by every collection the ring appears in.
(function () {
  if (window.__tsSwatches) return; window.__tsSwatches = true;
  var cache = {};
  function load(slot) {
    if (slot.dataset.tsState) return;
    slot.dataset.tsState = 'loading';
    var url = slot.getAttribute('data-ts-swatches');
    var p = cache[url] || (cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }));
    p.then(function (html) {
      if (!slot.isConnected) return;
      var wrap = document.createElement('div');
      wrap.innerHTML = html.trim();
      // No color/cut row for this product (e.g. its linked colors are unpublished):
      // show the carat-size / metal row the page already carries instead.
      if (!wrap.querySelector('.jtpl-pro-variant-cstm-gem, .jtpl-pro-variant-cstm')) {
        var fb = slot.querySelector('.ts-swatch-fallback');
        wrap.innerHTML = fb ? fb.innerHTML : '';
      }
      var nodes = Array.prototype.slice.call(wrap.childNodes);
      var card = slot.closest('.grid__item, li');
      slot.replaceWith.apply(slot, nodes);
      if (card && window.jQuery && typeof window.initGridItemHover === 'function') {
        try { window.initGridItemHover(window.jQuery(card)); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('ts:swatches-loaded', { detail: { card: card } }));
    });
  }
  // The theme hides empty divs (div:empty { display:none }), so watch the card
  // the slot sits in, not the slot itself.
  var slotOf = typeof WeakMap === 'function' ? new WeakMap() : null;
  var io = ('IntersectionObserver' in window && slotOf) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      (slotOf.get(en.target) || []).forEach(load);
    });
  }, { rootMargin: '800px 0px' }) : null;
  function scan(root) {
    (root || document).querySelectorAll('.ts-swatch-slot:not([data-ts-state]):not([data-ts-watched])').forEach(function (s) {
      if (!io) return load(s);
      s.setAttribute('data-ts-watched', '');
      var target = s.closest('.inventory_detail, .grid__item, li') || s.parentElement;
      var list = slotOf.get(target);
      if (list) list.push(s); else { slotOf.set(target, [s]); io.observe(target); }
    });
  }
  function loadRest() {
    document.querySelectorAll('.ts-swatch-slot:not([data-ts-state])').forEach(load);
  }
  function start() {
    scan();
    // Fallback: background tabs never report visibility, so load whatever is
    // still waiting shortly after the page has finished loading.
    var later = function () { setTimeout(loadRest, 2500); };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
    // cards added later (View More, filters, sorting) bring new slots
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { scan(); break; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
